import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import * as fromRootStore from 'src/app/_apps/root/store';
import { BackAuthUserSearchResult } from 'src/app/_common/models/search-result';
import { ISearchCategory } from 'src/app/_apps/root/root.constants';
import { SearchCategory } from './search-category';
import { User } from 'src/app/_apps/auth/domain/models/back';

@Component({
    selector: 'aa-back-auth-user-category',
    templateUrl: './search-category.component.html',
    styleUrls: [
        './search-category.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BackAuthUserCategoryComponent extends SearchCategory<User> implements OnInit
{
    @Input() category: ISearchCategory;
    public results: Observable<BackAuthUserSearchResult[]> = of([]);

    constructor(private store: Store<IAuroraState>)
    {
        super();
    }

    ngOnInit ()
    {
        this.results = this.store
            .pipe(
                select(fromRootStore.getBackAuthUsersSearchResults)
            );
    }
}
